import React from "react";

export default function SortDropdown({ sortOrder, onChange }) {
	return (
		<div style={{ marginTop: 20, marginBottom: 10 }}>
			<label
				htmlFor="sortSelect"
				style={{ marginRight: 10, fontWeight: "600" }}>
				Sort Matches:
			</label>
			<select
				id="sortSelect"
				value={sortOrder}
				onChange={(e) => onChange(e.target.value)}
				style={{
					padding: "6px 10px",
					fontSize: 14,
					borderRadius: 4,
					border: "1px solid #ccc",
					cursor: "pointer",
				}}>
				<option value="score-desc">Score: High to Low</option>
				<option value="score-asc">Score: Low to High</option>
				<option value="company-asc">Company Name: A-Z</option>
				<option value="company-desc">Company Name: Z-A</option>
			</select>
		</div>
	);
}
